var $class="se2--wiztopic-press-release",$name="WiztopicPressRelease",$path="app/components/WiztopicPressRelease/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';
import Sharect from 'sharect';

import setYoutubeVideoThumbnail from 'app/utilities/setYoutubeVideoThumbnail';
import lazyHandleOpenModalButtons from 'app/components/utilities/lazyHandleOpenModalButtons';

import { linkedInSvg } from './sprites/linkedIn-icon';

import './partials/accordion';

const LINKEDIN_URL = 'https://www.linkedin.com/sharing/share-offsite/?url=PAGE_URL';

const initSharect = () => {
  const socialMedia = [{
    icon: linkedInSvg,
    url: LINKEDIN_URL,
  }];

  Sharect.appendCustomShareButtons(socialMedia).init();
};

export default shell.registerComponent($this, ({
  addEventListener, mount, configs,
}) => {
  mount((element) => {
    setYoutubeVideoThumbnail(element, configs.css.classNames.videoThumbnail);
    lazyHandleOpenModalButtons(addEventListener, element, [configs.css.classNames.videoThumbnail]);
    initSharect();
  });
});
